/* eslint-disable react/no-array-index-key */
import { Accordion } from 'react-bootstrap';
import { HeadingDescSmall } from '../Headings';
import './accordionComp.css';

function AccordionComp(props) {
  const { data } = props;
  return (
    <div className="accordionComp">
      <Accordion>
        {data.map((singleData, index) => {
          const { heading, desc, content } = singleData;
          return (
            <div key={index}>
              <Accordion.Item eventKey={index}>
                <Accordion.Header>
                  <HeadingDescSmall text={heading || ''} />
                </Accordion.Header>
                <Accordion.Body>
                  <HeadingDescSmall text={desc || ''} />
                  <HeadingDescSmall text={content || ''} />
                </Accordion.Body>
              </Accordion.Item>
            </div>
          );
        })}
      </Accordion>
    </div>
  );
}

export default AccordionComp;
